import { render, staticRenderFns } from "./OpportunitySelect.vue?vue&type=template&id=4caa3aeb&scoped=true&"
import script from "./OpportunitySelect.vue?vue&type=script&lang=js&"
export * from "./OpportunitySelect.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitySelect.vue?vue&type=style&index=0&id=4caa3aeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa3aeb",
  null
  
)

export default component.exports